import React from 'react';

interface Props {
  width?: number;
  height?: number;
  fill?: string | number;
}

function LogoWithTitleBelowIcon({
  width = 34,
  height = 34,
  fill = 'white',
  ...props
}: Props & React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 55 34"
      fill={fill}
      {...props}
    >
      <g fill="#71C8BE">
        <path
          opacity={0.6}
          d="M14.515 4.229v13.369h-2.308V2.068c0-1.245 1.27-1.955 2.156-1.206l10.967 9.251c.338.285.536.731.536 1.206v6.277h-2.308v-5.738l-9.043-7.63zM39.795 17.598V4.228l-9.645 7.63v5.74h-2.462v-6.277c0-.475.21-.921.572-1.206L39.957.863c.946-.75 2.3-.04 2.3 1.204v15.531h-2.462z"
        />
      </g>
      <g opacity={0.7} fill="#AADED8">
        <path d="M1.28 24.174c-.706 0-1.28.588-1.28 1.312v8.297h1.662v-7.189l2.242 3.749c.255.426.709.686 1.197.686.486 0 .94-.259 1.195-.685l2.254-3.751v7.187h1.662v-8.355c0-.691-.547-1.251-1.22-1.251-.433 0-.834.235-1.053.618l-2.807 4.9-2.745-4.863a1.27 1.27 0 00-1.106-.655z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.703 24.174c-.566 0-1.075.343-1.283.868l-3.485 8.741h1.66l1.082-2.516h3.946l1.082 2.516h1.762l-3.479-8.741a1.383 1.383 0 00-1.285-.868zm-.054 1.968l1.375 3.564h-2.756l1.381-3.564z"
        />
        <path d="M26.825 28.577l3.988-4.177a.724.724 0 01.524-.226c.658 0 .987.83.52 1.316l-3.163 3.282 4.665 5.011h-2.121l-4.413-4.652v4.652H25.19v-8.757c0-.47.366-.852.817-.852.452 0 .818.381.818.852v3.55zM36.083 32.245c0 .849.696 1.538 1.553 1.538h4.462c.438 0 .793-.35.793-.785a.788.788 0 00-.793-.784H37.81v-2.597h3.912c.439 0 .793-.35.793-.785a.788.788 0 00-.793-.784H37.81v-2.305h4.288c.438 0 .793-.35.793-.784a.788.788 0 00-.793-.785h-4.462c-.857 0-1.553.69-1.553 1.538v6.533z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M53.674 26.925c0 .307-.038.6-.114.88a2.839 2.839 0 01-.35.798 2.442 2.442 0 01-.65.69c-.272.203-.596.36-.971.473l2.875 4.017h-2.198L49.6 30.057h-1.616v3.726h-1.688v-8.07c0-.85.683-1.54 1.525-1.54h2.53c.202 0 .385.007.55.02.169.01.373.036.61.082.24.04.453.097.636.17.187.072.38.178.576.318.202.14.366.305.496.494.134.185.244.422.328.71.087.283.128.603.128.959zm-5.69-1.19v2.754h1.556c.269 0 .505-.01.711-.028.206-.018.418-.053.636-.107a1.63 1.63 0 00.537-.237c.144-.099.26-.237.348-.413.093-.175.14-.383.14-.622 0-.897-.686-1.346-2.057-1.346h-1.87z"
        />
      </g>
    </svg>
  );
}

const MemoLogoWithTitleBelowIcon = React.memo(LogoWithTitleBelowIcon);
export default MemoLogoWithTitleBelowIcon;
